var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tfa-setup"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Verifikasi Two-Factor Authentication (2FA)")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('img', {
    staticClass: "img-fluid ",
    attrs: {
      "width": "200",
      "height": "200",
      "src": _vm.$http.options.base + _vm.qr_code_url,
      "alt": "QR CODE"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.confirm($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "otp_verification"
    }
  }, [_vm._v("Masukkan OTP dari aplikasi Google Authenticator")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.otp_verification),
      expression: "otp_verification"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "otp_verification",
      "placeholder": "Masukkan OTP",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.otp_verification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.otp_verification = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {}, [_vm._v("Silahkan Scan Kode QR di bawah untuk menggunakan Two-Factor Authentication")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                      Confirm\n                    ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b905392","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tfasetup.vue
// module id = 407
// module chunks = 0